module.exports = require("./he.d.ts");